<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-doubleright`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.14237 4.02903C3.40192 3.76948 3.82404 3.76977 4.08378 4.02903L7.22928 7.17551C7.68425 7.63047 7.68424 8.36899 7.22928 8.82395L4.08378 11.9704L3.97928 12.0554C3.72116 12.2258 3.36961 12.1977 3.14237 11.9704C2.9155 11.7432 2.88701 11.3915 3.05741 11.1335L3.14237 11.029L6.17167 7.99973L3.14237 4.97043C2.88311 4.7107 2.88282 4.28858 3.14237 4.02903ZM8.41581 4.02903C8.67536 3.76948 9.09748 3.76977 9.35721 4.02903L12.5027 7.17551C12.9577 7.63047 12.9577 8.36899 12.5027 8.82395L9.35721 11.9704L9.25272 12.0554C8.9946 12.2258 8.64305 12.1977 8.41581 11.9704C8.18894 11.7432 8.16045 11.3915 8.33085 11.1335L8.41581 11.029L11.4451 7.99973L8.41581 4.97043C8.15655 4.7107 8.15625 4.28858 8.41581 4.02903Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDoubleright',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
